/**
 * Two CMS-seeded Unsplash photo IDs return HTTP 404. Keep live CMS overrides,
 * but serve bundled CC0 local copies for these specific broken legacy images.
 * Source: Wikimedia Commons, CC0: Paweł Szymankiewicz (MY), Annie Spratt (HK).
 */
const oldBrokenPhotoIds = {
  MY: { id: "photo-1596422846543-75c6fc197f11", asset: "/countries/malaysia.jpg" },
  HK: { id: "photo-1508007226346-fac16e15fa4c", asset: "/countries/hong-kong.jpg" },
};

export function publicCountryImage(country) {
  const url = country?.image || "";
  const fallback = oldBrokenPhotoIds[country?.code];
  return fallback && url.includes(fallback.id) ? fallback.asset : url;
}
